<template>
  <BaseSimuladorIndicadorModal
    ref="baseModal"
    :modal-id="modalId"
    title="Simulador"
    numerador-label="Numerador"
    denominador-label="Denominador"
    :valor-numerador="nManual"
    :valor-denominador="dManual"
    :base-numerador="baseNumerador"
    :base-denominador="baseDenominador"
    :procedimentos-numerador="PROCEDIMENTOS_NUMERADOR"
    :procedimentos-denominador="PROCEDIMENTOS_DENOMINADOR"
    :tipos="TIPOS_CLASSIFICACAO"
    :calculate-result-fn="calcularResultado"
    :calculate-class-fn="calcularClasse"
    :apply-preset-fn="aplicarPreset"
    :format-delta-fn="formatDelta"
    :result-text-fn="montarTextoResultado"
    hint="💡 Os botões preenchem valores de exemplo. Ajuste manualmente pelos controles acima."
    @update:numerador="setNumerador"
    @update:denominador="setDenominador"
  />
</template>

<script>
import BaseSimuladorIndicadorModal from '@/pages/IndicadoresAps/components/BaseSimuladorIndicadorModal.vue'

export default {
  name: 'SimuladorModal',
  components: {
    BaseSimuladorIndicadorModal,
  },
  props: {
    modalId: {
      type: String,
      default: 'simulador-modal',
    },
    dadosPercentualMunicipio: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualEquipe: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualMicroArea: {
      type: Object,
      default: () => ({}),
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nManual: 0,
      dManual: 1,
      baseNumerador: 0,
      baseDenominador: 1,
      TIPOS_CLASSIFICACAO: [
        { value: 'Ótimo', label: 'Ótimo', description: '> 5' },
        { value: 'Bom', label: 'Bom', description: '> 2,5 e <= 5' },
        {
          value: 'Suficiente',
          label: 'Suficiente',
          description: '> 1 e <= 2,5',
        },
        { value: 'Regular', label: 'Regular', description: '<= 1' },
      ],
      PROCEDIMENTOS_NUMERADOR: [
        {
          icon: null,
          codigo: null,
          desc: 'Atendimento Individual compartilhado entre profissional da eMulti e outro profissional de qualquer equipe.',
        },
        {
          icon: null,
          codigo: null,
          desc: 'Atividade Coletiva realizada ou com participação de profissional da eMulti.',
        },
        {
          icon: null,
          codigo: null,
          desc: 'Compartilhamento de cuidado no Atendimento Individual.',
        },
      ],
      PROCEDIMENTOS_DENOMINADOR: [
        {
          icon: null,
          codigo: null,
          desc: 'Total de ações realizadas por profissionais da eMulti.',
        },
      ],
    }
  },
  methods: {
    open() {
      this.aplicarFonte()
      this.$refs.baseModal.open()
    },

    close() {
      this.$refs.baseModal.close()
    },

    aplicarFonte() {
      let fonte = this.dadosPercentualMunicipio

      if (this.selectedMicroArea) {
        fonte = this.dadosPercentualMicroArea
      } else if (this.selectedEquipe) {
        fonte = this.dadosPercentualEquipe
      }

      const numerador = Number(fonte?.numerador) || 0
      const denominador = Number(fonte?.denominador) || 1

      this.nManual = numerador
      this.dManual = denominador
      this.resetBase()
    },

    setNumerador(valor) {
      this.nManual = valor
    },

    setDenominador(valor) {
      this.dManual = valor
    },

    resetBase() {
      this.baseNumerador = this.nManual
      this.baseDenominador = this.dManual
    },

    calcularResultado({ numerador, denominador }) {
      const d = Number(denominador) || 0
      if (d <= 0) return 0

      const n = Number(numerador) || 0
      return Number(((n / d) * 100).toFixed(2))
    },

    calcularClasse({ resultado }) {
      if (resultado > 5) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado > 2.5 && resultado <= 5) {
        return { nivel: 'Bom', variant: 'success' }
      }
      if (resultado > 1 && resultado <= 2.5) {
        return { nivel: 'Suficiente', variant: 'warning' }
      }
      if (resultado <= 1) return { nivel: 'Regular', variant: 'danger' }

      return { nivel: 'Regular', variant: 'danger' }
    },

    aplicarPreset({ tipo, setNumerador, setDenominador }) {
      if (tipo === 'Ótimo') {
        setNumerador(6)
        setDenominador(100)
      } else if (tipo === 'Bom') {
        setNumerador(3)
        setDenominador(100)
      } else if (tipo === 'Suficiente') {
        setNumerador(2)
        setDenominador(100)
      } else {
        setNumerador(1)
        setDenominador(100)
      }

      this.$nextTick(() => {
        this.resetBase()
      })
    },

    formatDelta(val) {
      if (val > 0) return `+${val}`
      if (val < 0) return `${val}`
      return ''
    },

    montarTextoResultado({ resultado }) {
      return `NM / DN × 100`
    },
  },
}
</script>
